import React, { FC, useEffect } from 'react';
import { Typography, TypographyVariant } from '@mui/material';
import { formatPageTitle } from '../../utils';

interface Props {
  title: string;
  color?: string;
  variant?: TypographyVariant;
}

export const setPageTitle = (title?: string) => {
  const validTitle = title?.trim();
  if (validTitle) {
    document.title = formatPageTitle(validTitle);
  }
};

export const PageTitle: FC<Props> = ({
  title,
  variant = 'h4',
  color = 'var(--text)',
}) => {
  const formattedTitle = formatPageTitle(title);

  useEffect(() => {
    setPageTitle(title);
  }, [title]);

  return (
    <Typography
      variant={variant}
      sx={{ fontSize: { xs: 24, sm: 32 } }}
      fontWeight={600}
      color={color}
    >
      {formattedTitle}
    </Typography>
  );
};
